/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:40:58
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ತೆರೆಯಿರಿ",
    name2: "ಮುಂಗಡ ಕಾಯ್ದಿರಿಸಿ",
    name3: "Carlcare ನೊಂದಿಗೆ, ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಆರ್ಡರ್ ಅನ್ನು ಪರಿಶೀಲಿಸಬಹುದು.",
    name4: "",
    name5: "ಬಲಕ್ಕೆ ಸ್ಲೈಡ್ ಮಾಡಿ",
    name6: "ದೃಢೀಕರಣ ಪೂರ್ಣಗೊಂಡಿದೆ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "ಸಾಧನದ ಮಾಡಲ್ ಅನ್ನು ಆರಿಸಿ",
    name2: "ದೋಷದ ವಿವರಣೆ:",
    name3: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್ ಆರಿಸಲು ತಟ್ಟಿ",
    name4: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್:",
    name5: "ರಿಸರ್ವೇಶನ್ ಸಮಯ:",
    name6: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಾಧನದ ಸಮಸ್ಯೆಯನ್ನು ವಿವರವಾಗಿ ವಿವರಿಸಿ!",
    name7: "ಆಗಮನ ಸಮಯವನ್ನು ಆರಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
    name8: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸರಿಯಾದ ಸಂಪರ್ಕ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ, ಇದರಿಂದ ನಾವು ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು",
    name9: "ಲಭ್ಯವಿರುವ ರಿಸರ್ವೇಶನ್ ಸಮಯ ಹೀಗಿದೆ",
    name10: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    name11: "ಬೆಲೆ",
    name12: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ:",
    name13: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರು ನಮೂದಿಸಿ",
    name14: "ಸಲ್ಲಿಸಿ",
    name15: "ರದ್ದುಗೊಳಿಸಿ",
    name16: "ಸರಿ",
  },
  shops: {
    name1: "ನೀವು ಆರಿಸಿದ ಬ್ರ್ಯಾಂಡ್ ಅನ್ನು ಆಧರಿಸಿ, ಈ ಕೆಳಗಿನ ಮಳಿಗೆಗಳು ನಿಮಗೆ ಸೇವೆ ನೀಡಬಹುದು!",
    name2: "ಇನ್ನಷ್ಟು ರಿಟೇಲ್ ಸ್ಟೋರ್‌ಗಳಲ್ಲಿ ಶೀಘ್ರವೇ ಬರಲಿದೆ! ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕದಲ್ಲಿರಿ!",
  },
  price: {
    name1: "ಬ್ರ್ಯಾಂಡ್",
    name2: "ಮಾದರಿ",
    name3: "ಐಟಂ",
    name4: "ಬೆಲೆ",
    name5: "ಸ್ನೇಹಪೂರ್ವಕ ಜ್ಞಾಪನೆ:",
    name6: "ಈ ಬೆಲೆಗಳು ಉಲ್ಲೇಖಕ್ಕಾಗಿ ಮಾತ್ರ, ಮತ್ತು ನಿಜವಾದ ಬೆಲೆಯು ನಿಮ್ಮ ಸಾಧನದ ಸ್ಥಿತಿಯನ್ನು ಅವಲಂಬಿಸಿರುತ್ತದೆ.",
    name7: "ಒಂದು ವೇಳೆ ವಿಶೇಷ ಚಿಹ್ನೆ ಇರದಿದ್ದಲ್ಲಿ, ಬೆಲೆಯ ಯುನಿಟ್ ಸ್ಥಳೀಯ ಕರೆನ್ಸಿ ಯುನಿಟ್ ಆಗಿರುತ್ತದೆ.",
    name8: "ಕ್ಷಮಿಸಿ! ಪ್ರಸ್ತುತ ಪ್ರದೇಶದಲ್ಲಿ ಯಾವುದೇ ಬೆಲೆ ಮಾಹಿತಿ ಲಭ್ಯವಿಲ್ಲ.",
    name11:"ಕಾರ್ಮಿಕರ ವೆಚ್ಚ",
    name12:"ಒಟ್ಟು ಬೆಲೆ",
    name13: "5. ಕಾರ್ಮಿಕ ವೆಚ್ಚವು \"/\" ಆಗಿದ್ದರೆ, ಕಾರ್ಮಿಕ ವೆಚ್ಚವನ್ನು ಸ್ಟೋರ್‌ನೊಂದಿಗೆ ಸಮಾಲೋಚಿಸಬೇಕು ಎಂದರ್ಥ.",
    item_main_board: "ಮೈನ್‌ಬೋರ್ಡ್",
    item_screen_frame: "ಸ್ಕ್ರೀನ್ (ಫ್ರೇಮ್)",
    item_screen_screen_frame: "ಸೆಕೆಂಡರಿ ಸ್ಕ್ರೀನ್ (ಫ್ರೇಮ್)",
    item_touch_screen: "ಟಚ್ ಸ್ಕ್ರೀನ್",
    item_camera: "\"ಕ್ಯಾಮರಾ\"",
    item_fixed_focus_camera: "ಸ್ಥಿರ ಫೋಕಸ್ ಕ್ಯಾಮೆರಾ",
    item_auto_focus_camera: "ಆಟೋ ಫೋಕಸ್ ಕ್ಯಾಮೆರಾ",
    item_screen: "ಸ್ಕ್ರೀನ್",
    item_secondary_screen: "ಸೆಕೆಂಡರಿ ಸ್ಕ್ರೀನ್",
    item_fingerprint_module: "ಬೆರಳಚ್ಚು ಮಾಡ್ಯೂಲ್",
    item_speaker: "ಸ್ಪೀಕರ್‌",
    item_receiver: "ಸ್ವೀಕರಿಸುವವರು",
    item_small_board: "ಸಣ್ಣ ಬೋರ್ಡ್",
    item_battery_cover: "ಬ್ಯಾಟರಿ ಕವರ್",
    item_battery: "ಬ್ಯಾಟರಿ",
    item_charger: "ಚಾರ್ಜರ್",
    item_usb_cable: "USB ಕೇಬಲ್",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ಮಾಹಿತಿ ಇಲ್ಲ",
    name2: "ಸೇವೆ ಒದಗಿಸುವವರು:",
    name3: "ಸೇವಾ ಬ್ರ್ಯಾಂಡ್:",
    name4: "ಟೆಲಿಫೋನ್:",
    name5: "ಆರ್ಡರ್ ಪ್ರಮಾಣ:",
    name6: "ಸೇವಾ ರೇಟಿಂಗ್",
    name7: "ಸೇವಾ ಪರಿಸರ:",
    name8: "ಸೇವಾ ಆ್ಯಟಿಟ್ಯೂಡ್:",
    name9: "ಸೇವಾ ದಕ್ಷತೆ:",
    name10: "ಸೇವಾ ಗುಣಮಟ್ಟ:",
    name11: "ಗ್ರಾಹಕ ಮೌಲ್ಯಮಾಪನ",
    name12:"ಗೆ",
    name13:"ಮುಚ್ಚಿದೆ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ತೆರೆಯಿರಿ",
    name1: "ದಯವಿಟ್ಟು ಮೀಸಲಾತಿ ಮಾಹಿತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ತೆಗೆದಿಡಿ ಮತ್ತದನ್ನು ಆದ್ಯತೆಯ ಸೇವೆಗೆ ಆಕ್ಸೆಸ್ ಪಡೆಯಲು ರಶೀದಿ ರೂಪದಲ್ಲಿ ಸೇವ್ ಮಾಡಿ.",
    name2: "ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ",
    name3: "1. ಡೇಟಾ ತೆರವುಗೊಳಿಸಿ",
    name4: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿರುವ ಪ್ರಮುಖ ಖಾಸಗಿ ಡೇಟಾವನ್ನು ಮುಂಚಿತವಾಗಿ ಬ್ಯಾಕಪ್ ಮಾಡಿ",
    name5: "2.ಪವರ್-ಆನ್ ಪಾಸ್‌ವರ್ಡ್ ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
    name6: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್‌ಗೆ ಹೋಗುವ ಮೊದಲು, ದಯವಿಟ್ಟು:",
    name7: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್:",
    name8: "ರಿಸರ್ವೇಶನ್ ಸಮಯ:",
    name9: "ದೋಷದ ವಿವರಣೆ:",
    name10: "ಸಾಧನದ ಮೋಡೆಲ್:",
    name11: "ಆರ್ಡರ್ ಸಂಖ್ಯೆ:",
    name12: "ಆರ್ಡರ್ ಮಾಹಿತಿ",
  },
  title: {
    
    name1: "ಈ ಕೆಳಗಿನ ದೇಶಗಳಿಗೆ ಬೆಂಬಲಿಸುತ್ತದೆ:",
    name2: "ಮಾಡೆಲ್ ಅನ್ನು ಆರಿಸಿ",
    name3: "ಕಾಯ್ದಿರಿಸುವಿಕೆ",
    name4: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್  ವಿವರಗಳು",
    name5: "ಸರ್ವೀಸ್ ಸ್ಟೋರ್ ಆಯ್ಕೆ ಮಾಡಿ",
  },
  error: {
    
    name1: "ಡೇಟಾ ಇಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ದುರಸ್ತಿ ಮಾಹಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ",
    name2: "ಹೆಚ್ಚಿನ ಸಹಾಯ ಬೇಕೇ? ದಯವಿಟ್ಟು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    name3: "ಕ್ಷಮಿಸಿ, ಪ್ರಸ್ತುತ ಪ್ರದೇಶದಲ್ಲಿ ಯಾವುದೇ Carlcare ಸೆಂಟರ್ ಇಲ್ಲ.",
    name4: "ದಯವಿಟ್ಟು ಮೊದಲು ಸೇವಾ ಕೇಂದ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    name5: "ವಿಫಲವಾಗಿದೆ",
    name6: "ದಯವಿಟ್ಟು ಮೊದಲು ಸಾಧನದ ಮೋಡೆಲ್ ಆಯ್ಕೆ ಮಾಡಿ",
    name7: "ವಿವರಗಳು",
    name8: "ದಯವಿಟ್ಟು ವಿವರವಾಗಿ ನಿಮ್ಮ ಅಗತ್ಯತೆಗಳನ್ನು ವಿವರಿಸಿ",
    name9: "",
  },
  add1:{
    "name0": "kn-rIN",
    "name1": "ನಿಮ್ಮ ಆರ್ಡರ್ ಅನ್ನು ದೃಢೀಕರಿಸಲಾಗಿದೆ. ನಿಮ್ಮ ಅರೈವಲ್ ಅನ್ನು ನಾವು ಎದುರು ನೋಡುತ್ತಿದ್ದೇವೆ.",
    "name2": "ನಗರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    "name3": "ದಯವಿಟ್ಟು%1$s ಅಂಕಿಗಳ ಫೋನ್ ನಂಬರ್ ನಮೂದಿಸಿ.",
    "name4": "ವಾರದ ದಿನದ ಗಂಟೆಗಳು",
    "name5": "\"ಸೋಮವಾರ\"",
    "name6": "ಮಂಗಳವಾರ",
    "name7": "ಬುಧವಾರ",
    "name8": "ಗುರುವಾರ",
    "name9": "ಶುಕ್ರವಾರ",
    "name10": "\"ಶನಿವಾರ\"",
    "name11": "\"ಭಾನುವಾರ\"",
    "name12": "ದೇಶವನ್ನು ನಮೂದಿಸಿ ಮತ್ತು ಹುಡುಕಿ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "ಇತರರು",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ಮರುನಿರ್ದೇಶಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
    name3:"ಆರ್ಡರ್ ಅನ್ನು ರೇಟ್ ಮಾಡಲು Carlcare ಅಪ್ಲಿಕೇಶನ್ ತೆರೆಯಿರಿ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ಸೇವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    name7:"ಉಚಿತ ಶುಚಿಗೊಳಿಸುವಿಕೆ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ತಪ್ಪಾದ ಮಾಹಿತಿ",
    "cancelReason1": "ಸರಿಯಾದ ಸಮಯಕ್ಕೆ ಬರಲು ಸಾಧ್ಯವಿಲ್ಲ",
    "cancelReason2": "ಡ್ಯುಪ್ಲಿಕೇಟ್ ಆರ್ಡರ್/ ನನ್ನ ಆರ್ಡರ್ ಅಲ್ಲ",
    "cancelReason3": "ವೈಫಲ್ಯ ಪುನರಾವರ್ತಿಸುವುದಿಲ್ಲ",
    "cancelReason4": "ಕೇವಲ ಪರೀಕ್ಷೆ/ವಿಚಾರಣೆ/ ಘಟನೆಗಾಗಿ/…",
    "cancelReason5": "ಅಧಿಕ ದರ",
    "cancelReason6": "ಮೆಟೀರಿಯಲ್‌ನ ಕೊರತೆ",
    "cancelReason7": "ಯಾವುದೇ ರೀತಿಯ ವಿಭಿನ್ನ ಸೇವೆಗಳಿಲ್ಲ",
    "cancelReason8": "ಸ್ಟೋರ್ ತೀರಾ ದೂರವಿದೆ",
    "cancelReason9": "ಸ್ಟೋರ್ ಮುಚ್ಚಿದೆ",
    "cancelReason10": "ಕೆಟ್ಟ ಸೇವಾ ವರ್ತನೆ",
    "cancelReason11": "ಇತರೆ ಬ್ರ್ಯಾಂಡ್‌ಗಳಿಗೆ ಬದಲಿ/ದುರಸ್ತಿ",
    "cancelReason12": "ಸ್ಟೋರ್ ಅನ್ನು ಹುಡುಕಲಾಗಲಿಲ್ಲ",
    "cancelReason13": "\"ಇತರ\"",
    "cancelOrder": "ಆರ್ಡರ್ ರದ್ದು ಮಾಡಿ",
    "reason_dialog_title": "ದಯವಿಟ್ಟು ರದ್ದತಿಗೆ ಕಾರಣವನ್ನು ತಿಳಿಸಿ",
    "Cancel": "ರದ್ದುಗೊಳಿಸಿ",
    "OK": "ಸರಿ",
    "name1": "ವೆರಿಫಿಕೇಶನ್ ಕೋಡ್ ನಮೂದಿಸಿ",
    "name2": "ಅಮಾನ್ಯಪರಿಶೀಲನಾ ಕೋಡ್",
    "repair_reservation_detail_canceled": "ಈ ಆರ್ಡರ್ ಅನ್ನು ರದ್ದು ಮಾಡಲಾಗಿದೆ!",
    "purchase_cancel_dialog_content": "ಆರ್ಡರ್ ಅನ್ನು ರದ್ದುಗೊಳಿಸಲು ನೀವು ಖಚಿತಪಡಿಸುತ್ತೀರಾ?",
    "yes": "ಹೌದು",
    "no": "ಇಲ್ಲ"
}
};
